<template>
  <van-cell class="radio-cell" :title="title" @click="updateValue">
    <template #right-icon>
      <van-radio class="radio" :name="value">
        <template #icon>
          <em
            v-if="activeValue === value"
            class="iconfont icon-dui radio-cell-check"
          ></em>
          <em v-else class="iconfont icon-uncheck radio-cell-uncheck"></em>
        </template>
      </van-radio>
    </template>
  </van-cell>
</template>

<script>
export default {
  name: 'CellRadio',
  emits: ['updateValue'],
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      required: true
    },
    activeValue: {
      type: String,
      required: true
    }
  },
  methods: {
    updateValue() {
      this.$emit('updateValue', this.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.radio-cell {
  overflow: hidden;
  box-sizing: border-box;
  height: 100px;
  padding: 0 20px 0 30px;
  background-color: var(--block-bg-light-color);
  border-radius: var(--border-radius);
  color: var(--text-color);

  &-uncheck,
  &-check {
    font-size: 38px;
  }
  &-uncheck {
    color: var(--text-color);
  }
  &-check {
    color: var(--main-color);
  }

  ::v-deep .van-cell__title {
    display: flex;
    align-items: center;
    font-size: 24px;
    color: var(--text-color);
  }
  ::v-deep .van-radio__icon {
    font-size: 24px;
  }
}
</style>
